import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useIframeLocationChange = () => {
  const location = useLocation()
  // Send Location Change Messages From Iframe Window
  useEffect(() => {
    const handleLocationChange = () => {
      const urlParams = new URLSearchParams(location.search)
      urlParams.delete('embed_mode')
      const searchString = urlParams.toString()

      window.parent.postMessage(
        {
          type: 'IFRAME_LOCATION_CHANGE',
          location: {
            ...location,
            search: searchString ? `?${searchString}` : '',
          },
        },
        '*'
      )
    }
    handleLocationChange()
  }, [location])
}

export default useIframeLocationChange
